import axios from '../api/axiosInstance';

export const fetchQuickOrderCategories = (params = {}) => {
  return axios.get('/quick-order-categories', { params });
};

export const createQuickOrderCategory = (data) => {
  return axios.post('/quick-order-categories', data);
};

export const updateQuickOrderCategory = (id, data) => {
  return axios.put(`/quick-order-categories/${id}`, data);
};

export const updateQuickOrderCategoryStatus = (id, status) => {
  return axios.patch(`/quick-order-categories/${id}/status`, { status });
};

export const deleteQuickOrderCategory = (id) => {
  return axios.delete(`/quick-order-categories/${id}`);
};

export const fetchQuickOrderProducts = (params = {}) => {
  return axios.get('/quick-order-products', { params });
};

export const createQuickOrderProduct = (data) => {
  return axios.post('/quick-order-products', data);
};

export const updateQuickOrderProduct = (id, data) => {
  return axios.put(`/quick-order-products/${id}`, data);
};

export const updateQuickOrderProductStatus = (id, status) => {
  return axios.patch(`/quick-order-products/${id}/status`, { status });
};

export const deleteQuickOrderProduct = (id) => {
  return axios.delete(`/quick-order-products/${id}`);
};

export const fetchQuickOrderSuggestions = () => {
  return axios.get('/quick-order-categories', {
    params: {
      includeProducts: 1,
      onlyActive: 1,
      sortBy: 'displayOrder',
      sortOrder: 'ASC',
      limit: 200,
    },
  });
};
